<script lang="ts">
  interface Props {
    lastUpdated?: string;
    verifiedOn?: string;
    completedOn?: string;
    isFailed?: boolean;
  }

  let {
    lastUpdated = '',
    verifiedOn = '',
    completedOn = '',
    isFailed = false
  }: Props = $props();
</script>

<div class="meta">
  {#if lastUpdated}
    <div class="meta-i">Source last updated: {lastUpdated}</div>
  {/if}
  {#if verifiedOn}
    <div class="meta-i">Verified: {verifiedOn}</div>
  {:else if isFailed && completedOn}
    <div class="meta-i">Completed: {completedOn}</div>
  {/if}
</div>

<style>
  .meta {
    display: flex;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    min-height: 18px;
    color: var(--grey-medium);
    margin-top: 16px;
  }
  .meta-i {
    display: flex;
    align-items: center;
  }
  .meta-i:not(:last-child) {
    margin-right: 4px;
  }
  .meta-i:not(:last-child)::after {
    content: '';
    width: 1px;
    height: 10px;
    background-color: var(--grey-medium);
    display: block;
    margin-left: 4px;
  }
</style>
